import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { getCurrentUser } from 'aws-amplify/auth';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const user = await getCurrentUser();
      if (!user) {
        this.router.navigate(['/']);
        return false;
      }

      const requiredGroups = route.data['requiredGroups'] as string[] | undefined;
      if (!requiredGroups?.length) {
        return true;
      }

      const groups = await this.authService.getUserGroupsWithFallback(user.username);
      const hasRequiredGroup = requiredGroups.some((group) => groups.includes(group));

      if (!hasRequiredGroup) {
        this.router.navigate(['/']);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Auth guard error:', error);
      this.router.navigate(['/']);
      return false;
    }
  }
}
